import { __assign, __decorate, __extends, __metadata } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { BindPropsHelper } from './PropTypes';
import { InputHelpers } from './InputHelpers';
import { Misc, Utils } from '@singularsystems/neo-core';
import ComponentBase from './ComponentBase';
import { FormContext } from './FormContext';
import { Button } from './_Exports';
import { makeObservable, observable } from 'mobx';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.domRef = React.createRef();
        _this.showPassword = false;
        _this.onChanged = _this.onChanged.bind(_this);
        makeObservable(_this);
        return _this;
    }
    Input.prototype.determineType = function () {
        var type = null;
        if (this.baseType) {
            type = this.baseType;
        }
        if (!type && this.props.input) {
            if (this.props.input.showPasswordButton) {
                type = this.showPassword ? "text" : "password";
            }
            else if (this.props.input.type) {
                type = this.props.input.type;
            }
        }
        if (!type) {
            if (typeof this.props.bind.value === "boolean" || this.props.bind.propertyInfo.propertyType === Misc.DataType.NullableBoolean) {
                type = "checkbox";
            }
            else {
                type = "text";
            }
        }
        return type;
    };
    Input.prototype.afterRender = function () {
        if (this.domRef.current && this.type === "checkbox") {
            this.domRef.current.indeterminate = this.props.bind.value === null;
        }
    };
    Input.prototype.onChanged = function (e) {
        if (this.props.bind.propertyInfo.propertyType === Misc.DataType.NullableBoolean) {
            if (e.target.checked && this.props.bind.value === false) {
                this.props.bind.value = null;
                return;
            }
        }
        this.props.bind.value = this.type == "checkbox" ? e.target.checked : e.target.value;
    };
    Input.prototype.render = function () {
        var _this = this;
        var _a;
        this.type = this.determineType();
        var splitProps = BindPropsHelper.normaliseEditorProps(this, this.props);
        var domProps = BindPropsHelper.autoSetDomProperties(splitProps, this.context);
        var inputProps = (_a = splitProps.input) !== null && _a !== void 0 ? _a : {};
        var showPasswordButton = inputProps === null || inputProps === void 0 ? void 0 : inputProps.showPasswordButton;
        var displayInfo = this.props.bind.validator.getDisplayState(this.context.validationDisplayMode);
        displayInfo.applyToDom(domProps, !splitProps.inGroup);
        var bindValue = this.props.bind.value;
        if (this.type === "checkbox" || this.type === "switch") {
            domProps.checked = bindValue === true;
            domProps.className = " custom-control-input";
            // Bootstrap custom checkboxes don't honour the readonly attribute.
            if (domProps.readOnly) {
                domProps.disabled = true;
            }
            if (this.props.label) {
                inputProps.label = this.props.label;
            }
            this.type = "checkbox";
        }
        else {
            domProps.value = (bindValue === undefined || bindValue === null) ? "" : bindValue;
            domProps.className = Utils.joinWithSpaces(domProps.className, splitProps.isBootstrap ? "form-control" : "neo-forms-editor");
        }
        var isInput = (!inputProps.rows || inputProps.rows == 1);
        domProps.onChange = this.onChanged;
        var inputElement;
        if (splitProps.editor.inputElement)
            this.domRef = splitProps.editor.inputElement;
        if (isInput) {
            inputElement = React.createElement("input", __assign({}, domProps, { ref: this.domRef, type: this.type }));
        }
        else {
            inputElement = React.createElement("textarea", __assign({}, domProps, { ref: this.domRef, rows: inputProps.rows }));
        }
        if (this.type === "checkbox") {
            inputElement = React.createElement("div", { className: "custom-control custom-" + ((inputProps === null || inputProps === void 0 ? void 0 : inputProps.type) === "switch" ? "switch" : "checkbox") },
                inputElement,
                React.createElement("label", { htmlFor: domProps.id, className: "custom-control-label" }, (inputProps.label ? inputProps.label : "")));
        }
        if (showPasswordButton) {
            var buttonOptions = { variant: "primary", isOutline: true };
            if (typeof showPasswordButton === "object") {
                buttonOptions = showPasswordButton;
            }
            splitProps.editor.requiresGroup = true;
            splitProps.editor.append = this.props.bind.value ?
                React.createElement(Button, __assign({ size: "sm" }, buttonOptions, { icon: !this.showPassword ? "far-eye fa-fw" : "far-eye-slash fa-fw", onClick: function () { return _this.showPassword = !_this.showPassword; } })) : null;
        }
        return (InputHelpers.surroundWithInputGroup(inputElement, splitProps.editor, this.domRef));
    };
    Input.contextType = FormContext;
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], Input.prototype, "showPassword", void 0);
    Input = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Input);
    return Input;
}(ComponentBase));
export default Input;
var Textbox = /** @class */ (function (_super) {
    __extends(Textbox, _super);
    function Textbox(props) {
        var _this = _super.call(this, props) || this;
        _this.baseType = "text";
        return _this;
    }
    return Textbox;
}(Input));
export { Textbox };
var Passwordbox = /** @class */ (function (_super) {
    __extends(Passwordbox, _super);
    function Passwordbox(props) {
        var _this = _super.call(this, props) || this;
        _this.baseType = "password";
        return _this;
    }
    return Passwordbox;
}(Input));
export { Passwordbox };
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.baseType = "checkbox";
        return _this;
    }
    return Checkbox;
}(Input));
export { Checkbox };
